var map = {
	"./abc.txt": 4
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;



/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources (webpack)/~/raw-loader!^\.\/.*\.txt$
 ** module id = 3
 ** module chunks = 0
 **/